import Vue from 'vue'
/*
|---------------------------------------------------------------------
| Board Vuex Mutations
|---------------------------------------------------------------------
|
| Synchronous operations for board store
|
*/
export default {
  /* ---------------------------------- COTIZACIONES MUTATIONS --------------------------------- */

  setItem: (state, item) => {
    // state.items = items
    state.all_data.items.splice(state.all_data.items.length, 0, item);
  },

  removeItem: (state, index) => {
    state.all_data.items.splice(index, 1)
  },

  updateItem: (state, obj) => {
    let item = state.all_data.items.find(item => item.id == obj.index)
    item.nombre = obj.nombre;
  },

  setRow: (state, obj) => {
    let item = state.all_data.items.find(item => item.id == obj.index)
    item.rows.splice(item.rows.length, 0, obj.row);
  },

  updateRow: (state, obj) => {
    let item = state.all_data.items.find(item => item.id == obj.index)
    item.rows[obj.index2] = obj.row;
  },

  removeRow: (state, obj) => {
    let item = state.all_data.items.find(item => item.id == obj.index)
    item.rows.splice(obj.row, 1)
  },

  clearData: (state) => {
    state.step = 1
    
    state.all_data.data = {
      files_path: [],
    },
    state.all_data.final_files_path = [],
    state.all_data.items = [],
    state.all_data.items_ = [],
    state.all_data.documents = [],
    state.all_data.files_temp = [],
    state.all_data.email = {
      presentacion: true,
      destinatarios: [],
      reply_to: [],
    },

    state.all_data.form = {
      asunto: "",
      mensaje: "",
    },

    state.all_data.termino_validez_temp = null,
    state.all_data.comentario_temp = null,

    state.all_data.path_presentacion = null,
    state.all_data.selectedPropuesta = null,
    state.all_data.nombre_destinatario = "",
    state.all_data.email_destinatario = "",
    state.all_data.email_reply_to = "",
    state.all_data.nombre_reply_to = "",
    state.all_data.showAddDestinatarioDialog = false,
    state.all_data.createDialog = false,
    state.all_data.servicio = null,

    state.all_data.users = [],
    state.all_data.mesesContratoOptions = [],
    state.all_data.plazoPagoOptions = [],
    state.all_data.plazoHabilitacionOptions = [],

    state.all_data.isFormValid = true,
    state.all_data.rows = 2,
    state.all_data.urlPortal = process.env.VUE_APP_PORTAL,
    state.all_data.loading = false,
    state.all_data.load = false,

    setTimeout(() => {
      Vue.set(state.all_data.data, 'fecha_creacion', new Date().toISOString().split("T")[0])
      // Vue.set(state.all_data.data, 'termino_validez', new Date().toISOString().split("T")[0])
    }, 100);

  },

  nextStep: (state) => {
    state.step++
  },

  backStep: (state) => {
    state.step--
  },

  setUser: (state, user) => {
    Vue.set(state.all_data.data, 'id_cliente', user.id_cliente)
    Vue.set(state.all_data.data, 'nombre_cliente', user.nombre_cliente)
    Vue.set(state.all_data.data, 'atencion_a', user.atencion_a)
    Vue.set(state.all_data.data, 'atencion_email', user.atencion_email)
    Vue.set(state.all_data.data, 'atencion_telefono', user.atencion_telefono)

    let destinatario = {
      name: user.nombre_cliente,
      email: user.atencion_email
    }

    state.all_data.email.destinatarios = []
    state.all_data.email.destinatarios.splice(state.all_data.email.destinatarios.length, 0, destinatario);
  },


  setDestinatario: (state, destinatario) => {
    state.all_data.email.destinatarios.splice(state.all_data.email.destinatarios.length, 0, destinatario);
  },

  setReplyTo: (state, reply_to) => {
    state.all_data.email.reply_to.splice(state.all_data.email.reply_to.length, 0, reply_to);
  },

  deleteChip_: (state, index) => {
    state.all_data.data.files_path.splice(index, 1)
  },


  removeDestinatario: (state, index) => {
    state.all_data.email.destinatarios.splice(index, 1)
  },

  removeReplyTo: (state, index) => {
    state.all_data.email.reply_to.splice(index, 1)
  },

  // DATA STEP 1
  updateData_: (state, obj) => {
    Vue.set(state.all_data.data, obj.nombre,  obj.value)
  },

  updateEmail_: (state, obj) => {
    Vue.set(state.all_data.email, obj.nombre,  obj.value)
  },

  updateDocuments: (state, value) => {
    state.all_data.documents = value;
  },

  setFilePath: (state, file) => {
    state.all_data.data.files_path.splice(state.all_data.data.files_path.length, 0, file);
  }

}
